import Logan from 'logan-web';
import { encode } from 'js-base64';
import { getCookie } from '../utils';

const Track = {
  bind(el, binding, vnode) {
    el.handler = (e) => {
      const { value } = binding;
      const sqeuenceNumber = +sessionStorage.getItem('sqeuenceNumber');
      const g_conversationId = getCookie('g_conversationId');
      let params = value.params;
      let data = '';
      if (params) {
        params = typeof params === 'object' ? encode(params) : params;
        data = `${sqeuenceNumber},${g_conversationId},${value.pageName},Button Tapped,${params}`;
      } else {
        data = `${sqeuenceNumber},${g_conversationId},${value.pageName},Button Tapped`;
      }
      // eslint-disable-next-line import/no-named-as-default-member
      Logan.log(data, 1);
      sessionStorage.setItem('sqeuenceNumber', sqeuenceNumber + 1);
    };
    // 给元素添加绑定点击事件,埋点上报
    el.addEventListener('click', el.handler);
  },
  unbild(el) {
    el.removeEventListener('click', el.handler);
  },
};

export default Track;
